/// <reference types="@angular/localize" />

import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { isDevMode } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
// import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
// import { provideToastr } from 'ngx-toastr';
// import { BasicAuthInterceptor } from 'src/app/shared/interceptors/auth.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, NgxSpinnerModule),
    provideHttpClient(withInterceptors([authInterceptor])),
    // { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    // provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    })
    // provideAnimations(),
    // provideToastr({
    //   timeOut: 3000,
    //   positionClass: 'toast-bottom-right',
    //   preventDuplicates: true, // Prevents duplicate messages from showing up
    // }), // Toastr providers
  ]
}).catch((err: any) => console.error(err));

if (isDevMode()) {
  console.log('App is running in development mode. Angular DevTools should be active.');
} else {
  console.log('App is running in production mode. Angular DevTools will not be fully active.');
}
